import React,{useContext,useEffect,useState} from 'react'
import {useNavigate} from 'react-router-dom'
import Subheading from '../Text/Subheading'
import Text from '../Text/Text'
import ButtonPrimary from '../Buttons/ButtonPrimary'
import ButtonSecondary from '../Buttons/ButtonSecondary'
import Card from './Card'
import UserContext from '../../contexts/UserContext'

// Track session count in localStorage
function getSessionCount() {
    return parseInt(localStorage.getItem('flowsage_sessions')||'0',10)
}
function incrementSession() {
    const n=getSessionCount()+1
    localStorage.setItem('flowsage_sessions',String(n))
    return n
}

export default function FeedbackCard({hadAIInteraction=false}) {
    const navigate=useNavigate()
    const [show,setShow]=useState(false)
    const [user]=useContext(UserContext)

    useEffect(()=>{
        const feedbackSubmitted=localStorage.getItem('feedbackSubmitted')
        if(feedbackSubmitted) return

        const signupDate=user?.metadata?.creationTime
        const isNewUser=signupDate&&new Date()-new Date(signupDate)<3*24*60*60*1000
        if(isNewUser) return

        const sessions=incrementSession()
        const dismissed=localStorage.getItem('feedbackDismissed')

        // Show after 3rd session OR after first AI interaction, whichever comes first
        if(sessions>=3||hadAIInteraction) {
            if(!dismissed) setShow(true)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[hadAIInteraction])

    function dismiss() {
        localStorage.setItem('feedbackDismissed','true')
        setShow(false)
    }

    function submitFeedback() {
        localStorage.setItem('feedbackSubmitted','true')
        setShow(false)
        navigate('/forms/experience')
    }

    if(!show) return null

    return (
        <div className='fixed bottom-6 right-6 z-40 max-w-xs animate-fade-in' role="complementary" aria-label="Feedback request">
            <Card className='border border-primary shadow-xl'>
                <div className='flex items-start justify-between gap-2'>
                    <Subheading className='py-0'>Help us improve!</Subheading>
                    <button onClick={dismiss} className='text-gray-400 hover:text-gray-600 transition-colors mt-0.5' aria-label='Dismiss feedback'>✕</button>
                </div>
                <Text className='text-sm mt-1'>Answer a few quick questions to help shape Flowsage.</Text>
                <div className='flex gap-2 mt-4'>
                    <ButtonPrimary className='flex-1 !py-1.5 !text-sm' onClick={submitFeedback}>Take survey</ButtonPrimary>
                    <ButtonSecondary className='!w-auto px-3 !py-1.5 !text-sm' onClick={dismiss}>Later</ButtonSecondary>
                </div>
            </Card>
        </div>
    )
}
